/*
 * 企業側 ホットライン
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_CLIENT_HOTLINE = 'API_CREATE_CLIENT_HOTLINE';
export const API_CREATE_CLIENT_HOTLINE_REORDER = 'API_CREATE_CLIENT_HOTLINE_REORDER';
export const API_CREATE_CLIENT_HOTLINE_ADVICE_CONTACT = 'API_CREATE_CLIENT_HOTLINE_ADVICE_CONTACT';
/**
 * クライアント：ホットライン新規作成
 */
export const apiCreateClientHotline = ({ json }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE, `/client/hotline`, json, meta);
/**
 * クライアント：ホットライン再募集
 */
export const apiCreateClientHotlineReorder = ({ json, path: { id } }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE_REORDER, `/client/hotline/${id}/reorder`, json, meta);
/**
 * クライアント：ホットライン コンサル選定アドバイザーへの問い合わせ
 */
export const apiCreateClientHotlineAdviceContact = ({ json, path: { id } }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE_ADVICE_CONTACT, `/client/hotline/${id}/advice_contact`, json, meta);
